import axios from 'axios';

const api = axios.create({
  baseURL: '/api',
  withCredentials: true,
});

export const getCaptcha = async () => {
  const response = await api.get('/auth/captcha');
  return response.data;
};

export const loginUser = async payload => {
  const response = await api.post('/auth/login', payload);
  return response.data;
};

export const signupUser = async payload => {
  const response = await api.post('/auth/signup', payload);
  return response.data;
};

export const logoutUser = async () => {
  const response = await api.post('/auth/logout');
  return response.data;
};

export const fetchDashboard = async () => {
  const response = await api.get('/dashboard');
  return response.data;
};

export const createPayee = async payload => {
  const response = await api.post('/payees', payload);
  return response.data;
};

export const createTransfer = async payload => {
  const response = await api.post('/transfers', payload);
  return response.data;
};
